import { MDBIcon } from "mdb-react-ui-kit";
import React, { useState } from "react";
import ImageDetail from "../ImageDetail";

import styles from "./style.module.scss";

const ImageContainer = (
	{
		url,
		name,
		isContentPost,
		isPostForm,
		isAddCommentForm,
		action,
		deleteOption,
	},
	key
) => {
	const [isDetailOpen, setIsDetailOpen] = useState(false);
	const getClassName = () => {
		if (isContentPost) {
			return styles.contentPost;
		}
		if (isContentPost) {
			return styles.postContent;
		}
		if (isAddCommentForm) {
			return styles.commentForm;
		}
		return styles.default;
	};
	const imageAction = () => {
		if (isContentPost) {
			return setIsDetailOpen(!isDetailOpen);
		}
		if (!isPostForm) {
			return action();
		}
	};
	return (
		<>
			{isDetailOpen ? (
				<ImageDetail src={url} isOpen={isDetailOpen} onClose={imageAction} />
			) : (
				""
			)}
			<div className={styles.container}>
				<div className={styles.imageContainer}>
					<img
						key={key}
						className={getClassName()}
						onClick={imageAction}
						src={url}
						alt='Uploaded file'
					/>
				</div>
				<p className={styles.title}>{name}</p>
				{isPostForm && deleteOption ? (
					<div>
						<div className={styles.hoverContent} onClick={action}>
							<span className={styles.hoverIcon}>
								<MDBIcon fas icon='trash-alt' />
							</span>
							<span className='mr-1'>Delete</span>
						</div>
					</div>
				) : (
					""
				)}
			</div>
		</>
	);
};

export default ImageContainer;
